// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".glossary-word--word--15FXax8_ {\n  font-weight: bold;\n}\n.glossary-word--button--2IxjA002 {\n  margin-left: 10px;\n  padding: 3px 5px;\n  border: solid 1.5px #979797;\n  border-radius: 4px;\n  background-color: #b7e2ec;\n}\n.glossary-word--button--2IxjA002:hover,\n.glossary-word--button--2IxjA002:active,\n.glossary-word--button--2IxjA002.glossary-word--playing--DOBa7eC2 {\n  color: white;\n  background-color: #0592af;\n}\n", ""]);
// Exports
exports.locals = {
	"word": "glossary-word--word--15FXax8_",
	"button": "glossary-word--button--2IxjA002",
	"playing": "glossary-word--playing--DOBa7eC2"
};
module.exports = exports;
